<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        ListF Detail Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="regrid"
        >List</vs-button
      >
      <!--<p class="pr-4"></p>
      <vs-button color="success" type="filled" icon="add" @click="cusAdd"
        >Add</vs-button
      >
       <p class="pr-4"></p>
      <vs-button
        color="success"
        type="filled"
        icon="visibility"
        @click="cusAdd"
        v-if="btndis"
        >View</vs-button
      > 
      <p class="pr-4"></p>
      <vs-button
        color="warning"
        type="filled"
        icon="create"
        @click="cusEdit"
        v-if="btndis3"
        >Edit</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="danger"
        type="filled"
        icon="remove_circle_outline"
        @click="cusDel"
        v-if="btndis3"
        >Delete</vs-button
      >
      <p class="pr-4"></p>
      <vs-dropdown>
        <vs-button
          
          class="btn-drop"
          type="filled"
          icon="print"
          color="#5b3cc4"
          >QR Print</vs-button
        >
        <vs-dropdown-menu>
          <vs-dropdown-item @click="printSkus2">ALL</vs-dropdown-item>
          <vs-dropdown-item @click="printSkus">Selected</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <p class="pr-4"></p>
      <vs-button color="success" type="filled" icon="list" @click="goDetail" v-if="btndis">Skus</vs-button>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="list" @click="goPrint" v-if="btndis">PrintQR</vs-button> -->
      <p class="pr-4"></p>
      <vs-button
        color="success"
        type="filled"
        icon="check_circle"
        @click="goSystem"
        v-if="btndis3"
        >Confirm Out</vs-button
      >
      <p class="pr-4"></p>

      <!-- <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="more_horiz"
          color="success"
          v-if="btndis"
          >Confirm In</vs-button
        >

        <vs-dropdown-menu>
          <vs-dropdown-item @click="goPutawayAll">All</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown> -->
    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >

      <aggrid
        v-if="gridshow"
        key="gridshow"
        :masrec="masrec"
        @recsel="recsel"
        :companyGroupsCode="companyGroupsCode"
        @mousedown.middle.native="getXY"
      ></aggrid>
      <inberror v-if="errorshow" :key="errorshow" :errdata="errdata"></inberror>
    </transition-group>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./gridd.vue";
import inberror from "./inberror";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";
import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";

export default {
  data() {
    return {
      locationsCode: "",
      putawaysNumber: "",
      userid: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      skus_code: "",
      listfNumber: this.$route.params.id,
      errdata: null,
      errorshow: false,
      addshow: false,
      viewshow: false,
      gridshow: false,
      btndis: false,
      btndis3: false,
      comUpload: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        // { act: "goDetail", label: "Skus" },
        { act: "goPrint", label: "PrintQR" },
        { act: "goPutaway", label: "PutAway" },
        { act: "goPutselect", label: "PutAwaySelect" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async printSkus() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/cmansexsdetails/printCmanSkus`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            // console.log(response.data);
            this.contents = [];
            this.contents.push([
              {
                text: response.data.skus_code,
                bold: true,
                fontSize: 6,
                alignment: "center",
                margin: [0, 5, 0, 0],
              },
              {
                alignment: "justify",
                margin: [0, 10, 0, 0],
                columns: [
                  [
                    {
                      text: response.data.listfNumber,
                      bold: true,
                      fontSize: 6,
                      alignment: "left",
                    },
                    {
                      text: "Item - " + response.data.itemnum,
                      bold: true,
                      fontSize: 6,
                      alignment: "left",
                    },
                    {
                      text:
                        "Package - " +
                        response.data.totalpckamount +
                        " Package",
                      bold: true,
                      fontSize: 6,
                      alignment: "left",
                    },
                    {
                      text:
                        "GW - " +
                        this.formatnumber(response.data.totalgw) +
                        " KGM",
                      bold: true,
                      fontSize: 6,
                      alignment: "left",
                    },
                  ],
                  {
                    qr: response.data.skus_code,
                    fit: "40",
                    alignment: "center",
                  },
                ],
              },
              // { qr: response.data.code, fit: "50", alignment: "center" },
            ]);
            const docDefinition = {
              // a string or { width: number, height: number }
              // pageSize: "A4",
              pageSize: { width: 110, height: 65 },
              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "landscape",
              pageMargins: [10, 0, 0, 0],
              content: this.contents,
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 8,
                  bold: true,
                  alignment: "center",
                },
                // header: {
                //   fontSize: 18,
                //   bold: true,
                //   alignment: "right",
                //   margin: [0, 190, 0, 80],
                // },
                // subheader: {
                //   fontSize: 14,
                // },
                // superMargin: {
                //   margin: [20, 0, 40, 0],
                //   fontSize: 15,
                // },
              },
            };
            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };
            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    async printSkus2() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/cmansexsdetails/printCmanSkus2`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);
          // console.log(response.data.length);

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            // console.log(response.data);
            this.contents = [];
            for (let il = 0; il < response.data.length; il++) {
              // console.log(response.data[il].skus_code)
              this.contents.push([
                {
                  text: response.data[il].skus_code,
                  bold: true,
                  fontSize: 6,
                  alignment: "center",
                  margin: [0, 5, 0, 0],
                },
                {
                  alignment: "justify",
                  margin: [0, 10, 0, 0],
                  columns: [
                    [
                      {
                        text: response.data[il].listfNumber,
                        bold: true,
                        fontSize: 6,
                        alignment: "left",
                      },
                      {
                        text: "Item - " + response.data[il].itemnum,
                        bold: true,
                        fontSize: 6,
                        alignment: "left",
                      },
                      {
                        text:
                          "Package - " +
                          response.data[il].totalpckamount +
                          " Package",
                        bold: true,
                        fontSize: 6,
                        alignment: "left",
                      },
                      {
                        text:
                          "GW - " +
                          this.formatnumber(response.data[il].totalgw) +
                          " KGM",
                        bold: true,
                        fontSize: 6,
                        alignment: "left",
                      },
                    ],
                    {
                      qr: response.data[il].skus_code,
                      fit: "40",
                      alignment: "center",
                      pageBreak: "after",
                    },
                  ],
                },
                // { qr: response.data.code, fit: "50", alignment: "center" },
              ]);
            }
            const docDefinition = {
              // a string or { width: number, height: number }
              // pageSize: "A4",
              pageSize: { width: 110, height: 65 },
              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "landscape",
              pageMargins: [10, 0, 0, 0],
              content: this.contents,
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 8,
                  bold: true,
                  alignment: "center",
                },
                // header: {
                //   fontSize: 18,
                //   bold: true,
                //   alignment: "right",
                //   margin: [0, 190, 0, 80],
                // },
                // subheader: {
                //   fontSize: 14,
                // },
                // superMargin: {
                //   margin: [20, 0, 40, 0],
                //   fontSize: 15,
                // },
              },
            };
            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };
            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val, val2) {
      // console.log(val2);
      if (val2 == "OUTBOUND_COMPLETE") {
        this.btndis3 = false;
      } else {
        this.btndis3 = true;
      }

      this.btndis = true;
      this.recid = val;
      // console.log(this.recid);
    },
    cusAdd() {
      this.recid = 0;
      this.addshow = true;
      // this.viewshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.btndis3 = false;
      this.errorshow = false;
      this.acstate = "ADD";
    },
    grid() {
      this.addshow = false;
      this.viewshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.btndis3 = false;
      this.errorshow = false;
      this.$store.dispatch("setReportGrid", 0);
    },
    goBack() {
      this.viewshow = false;
      this.addshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.btndis3 = false;
      this.errorshow = false;
    },
    goBackMore() {
      // console.log(this.$route.path);
      this.lspage = localStorage.getItem("LS_Page");
      this.$router.replace(this.lspage);
    },
    goPrint() {
      var rec = this.recid;
      var res = rec.split(",");
      // console.log(res.length);
      if (res.length != 1) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Array Length Error",
          text: "Can't Select Multiple Record",
        });
      } else {
        const formData = {
          token: localStorage.getItem("token"),
          token2: localStorage.getItem("token2"),
          dbname: localStorage.getItem("dbname"),
          skus_code: this.recid,
        };
        axios
          .post("/ApiInbdPreprint", formData)
          .then((res) => {
            if (res.data.status == "error") {
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Print Error",
                text: res.data.message,
                fixed: true,
              });
            } else {
              let url = localStorage.getItem("appdb");
              let dbname = localStorage.getItem("dbname");
              window.open(
                url + "api/ApiInbdetailsPrint/" + this.recid + "/" + dbname
              );
            }
          })
          .catch((err) => {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Deleted Error",
              text: err,
            });
          });
      }
    },
    regrid() {
      // this.$router.replace("/Inbdetails/0");
      this.masrec = "0";
      this.gridshow = false;
      setTimeout(() => {
        this.grid();
      }, 1000);
    },
    cusEdit() {
      var rec = this.recid;
      var res = rec.split(",");
      // console.log(res.length);
      if (res.length != 1) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Array Length Error",
          text: "Can't Edit Multiple Record",
        });
      } else {
        this.addshow = true;
        this.gridshow = false;
        this.btndis = false;
        this.btndis3 = false;
        this.errorshow = false;
        this.acstate = "EDIT";
      }
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert,
      });
    },
    async acceptAlert() {
      var rec = this.recid;
      var res = rec.split(",");
      // console.log(res.length);
      if (res.length != 1) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Array Length Error",
          text: "Can't Edit Multiple Record",
        });
      } else {
        this.btndis = false;
        this.btndis3 = false;

        try {
          const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
          this.readonly = true;

          if (token) {
            const formData = {
              number: this.recid,
              editor: String(this.userid),
              companyGroupsCode: this.companyGroupsCode,
            };

            const response = await axios.post(
              `${BASE_API_URL}/outbound-svc/cmansexsdetails/delete`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response.data);

            if (response.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
              });
            } else {
              if (this.$store.state.reportgrid == 0) {
                this.$store.dispatch("setReportGrid", 1);
              } else {
                this.$store.dispatch("setReportGrid", 0);
              }

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Deleted Complete",
                text: response.data.message,
              });
            }
          }
        } catch (error) {
          this.data = [];
          this.total = 0;
          this.loading = false;
          // throw error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // this.$router.replace("/pages/login/");
        }
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    goSystem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Picking? ",
        accept: this.goSystemPick,
      });
    },
    async goSystemPick() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exbdetails/exbCnpick`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });

            this.errdata = response.data.errdata;
            this.errorshow = true;
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "exbCnpick Complete",
              text: response.data.message,
            });

            this.pickOrdersNumber = response.data.picknum;

            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            localStorage.setItem("LS_Page", this.$route.path);
            this.$router.replace("/pickdetails/" + this.pickOrdersNumber);



            // const formData2 = {
            //   number: response.data.pickdetail[0].number,
            //   editor: String(this.userid),
            //   companyGroupsCode: this.companyGroupsCode,
            // };

            // const response2 = await axios.post(
            //   `${BASE_API_URL}/outbound-svc/exbdetails/cnPick`,
            //   formData2,
            //   {
            //     headers: { Authorization: "Bearer " + token.accessToken },
            //   }
            // );
            // // console.log(response2.data);

            // if (response2.data.status != "success") {
            //   this.loading = false;
            //   this.$vs.notify({
            //     position: "top-right",
            //     color: "danger",
            //     title: "Error from Backend",
            //     text: response2.data.message,
            //   });

            //   this.errdata = response2.data.errdata;
            //   this.errorshow = true;
            // } else {
            //   this.$vs.notify({
            //     position: "top-right",
            //     color: "success",
            //     title: "cnPick Complete",
            //     text: response2.data.message,
            //   });

            //   const formData3 = {
            //     pickOrdersNumber: this.pickOrdersNumber,
            //     editor: String(this.userid),
            //     companyGroupsCode: this.companyGroupsCode,
            //   };

            //   const response3 = await axios.post(
            //     `${BASE_API_URL}/outbound-svc/exbdetails/cnShipItemTMO`,
            //     formData3,
            //     {
            //       headers: { Authorization: "Bearer " + token.accessToken },
            //     }
            //   );
            //   // console.log(response3.data);

            //   if (response3.data.status != "success") {
            //     this.loading = false;
            //     this.$vs.notify({
            //       position: "top-right",
            //       color: "danger",
            //       title: "Error from Backend",
            //       text: response3.data.message,
            //     });

            //     this.errdata = response3.data.errdata;
            //     this.errorshow = true;
            //   } else {
            //     this.$vs.notify({
            //       position: "top-right",
            //       color: "success",
            //       title: "Ship Complete",
            //       text: response3.data.message,
            //     });

            //     if (this.$store.state.reportgrid == 0) {
            //       this.$store.dispatch("setReportGrid", 1);
            //     } else {
            //       this.$store.dispatch("setReportGrid", 0);
            //     }
            //   }
            // }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    hideFab() {
      this.btndis = false;
      this.btndis3 = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  components: {
    aggrid,
    inberror,
  },
  // mounted() {
  //   this.checkProfiles();
  //   // console.log(this.$acl.check('admin'));
  // },
  created() {
    this.checkProfiles();
    // console.log(this.inborders_number);
    this.masrec = this.listfNumber;
    // console.log(this.masrec);
    if (this.masrec != 0) {
      this.grid();
    }
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
